module.exports = __webpack_public_path__ + "static/media/test5_4.e98eaeee.png";